







import { getTimeString } from "@share/session/components/status-bar/StatusBarHelper";
import { DateTime, Interval } from "luxon";
import {Vue, Component, Prop, Watch} from "vue-property-decorator";

import LiveSvg from '../../../../assets/svg/live.svg';

@Component({components: {LiveSvg}})
export default class PlayerCountdown extends Vue {
    @Prop() endAt: DateTime | null;

    timeString = "";
    isDanger = false;
    timer: NodeJS.Timeout | null = null;

    mounted() {
        if (this.endAt) {
            this.watch();
        }
    }

    watch() {
        this.timer = setInterval(this.watchHandler, 1000);
    }

    @Watch('endAt')
    watchEndAt(value: DateTime | undefined) {
        if (!this.timer && value) {
            this.watch()
        } else if (!value && this.timer) {
            this.clearTimer();
        }
    }

    watchHandler() {

        if(!this.endAt) {
            return;
        }

        this.timeString = getTimeString(this.endAt);

        const interval = Interval.fromDateTimes(DateTime.local(), this.endAt);

        if (interval.isValid) {
            this.isDanger = Math.floor(interval.toDuration(['minutes']).get("minute")) < 1;
        }
        else if (interval.invalidReason == "end before start") {
            this.clearTimer();
        }
    }

    clearTimer() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    beforeDestroy() {
        this.clearTimer()
    }
}
